import { Component, HostBinding } from '@angular/core'
import { NavigationCancel, NavigationCancellationCode, NavigationEnd, NavigationError, Router } from '@angular/router'

import { linxioAnimations } from '@shared/animations'

@Component({
  selector: 'lin-content',
  templateUrl: './content.component.html',
  styleUrls: ['./content.component.scss'],
  animations: linxioAnimations,
  standalone: false,
})
export class LinxioContentComponent {
  @HostBinding('@routerTransitionUp') routeAnimationUp = false
  @HostBinding('@routerTransitionDown') routeAnimationDown = false
  @HostBinding('@routerTransitionRight') routeAnimationRight = false
  @HostBinding('@routerTransitionLeft') routeAnimationLeft = false
  @HostBinding('@routerTransitionFade') routeAnimationFade = false

  routerAnimation = 'fadeIn'

  // Shows a spinner only for the initial app load, not on every navigation. The index.html boot
  // loader covers Angular bootstrap; this covers the first router resolution while the shell and the
  // first screen load (including the '/' -> /login -> /v2/client/map redirect chain on entry). Once
  // the first screen has rendered we stop, so ordinary in-app navigation never shows a spinner.
  //
  // L30-2689: start cleared if a navigation already settled before this component existed. On a phone,
  // bootstrap-provider's checkIfMobile() navigates to /check-mobile-phone inside APP_INITIALIZER; that
  // NavigationEnd fires before lin-content is created and no later navigation follows, so waiting for
  // an event left the overlay over the mobile page for good and "I'd rather login here" was untappable.
  // A NavigationCancel clears it only when no navigation follows: Redirect and SupersededByNewNavigation
  // hand over to the next navigation (the guard redirects on entry), so the overlay waits for that one.
  isInitialLoad: boolean

  constructor(private router: Router) {
    this.isInitialLoad = !this.router.navigated
    this.router.events.subscribe((event) => {
      if (this.isInitialLoad && (event instanceof NavigationEnd || event instanceof NavigationError || this.isFinalCancel(event))) {
        this.isInitialLoad = false
      }

      if (event instanceof NavigationEnd) {
        switch (this.routerAnimation) {
          case 'fadeIn':
            this.routeAnimationFade = !this.routeAnimationFade
            break
          case 'slideUp':
            this.routeAnimationUp = !this.routeAnimationUp
            break
          case 'slideDown':
            this.routeAnimationDown = !this.routeAnimationDown
            break
          case 'slideRight':
            this.routeAnimationRight = !this.routeAnimationRight
            break
          case 'slideLeft':
            this.routeAnimationLeft = !this.routeAnimationLeft
            break
        }
      }
    })
  }

  private isFinalCancel(event: unknown): boolean {
    return (
      event instanceof NavigationCancel &&
      event.code !== NavigationCancellationCode.Redirect &&
      event.code !== NavigationCancellationCode.SupersededByNewNavigation
    )
  }
}
